<template>
  <el-dialog :visible="showModal" width="70%" :show-close="false" :modal-append-to-body="false" @close="$emit('close')">
    <div class="header">
      <div class="header-title">
        {{ detailData.name }}
        <div v-if="cameraDetail.length > 0" @click="openVideo" class="header-video-btn">
          <i class="el-icon-video-camera"></i>
          查看监控
        </div>
      </div>
      <div @click="showModal = false;" class="header-close"><i class="el-icon-close"></i></div>
    </div>

    <div class="charge-data-detail">
      <div class="detail-wrap">
        <div class="detail-left">
          <template v-if="propsData.zt === '正常'">
            <div class="detail-icon">
              <img src="../../assets/image/icon_normal.png" alt="">
            </div>
            <div class="detail-status green">{{ propsData.zt }}</div>
          </template>
          <template v-else>
            <div class="detail-icon">
              <img src="../../assets/image/icon_stop.png" alt="">
            </div>
            <div class="detail-status green">{{ propsData.zt }}</div>
          </template>
        </div>
        <div class="detail-main">
          <div class="detail-row">
            <div class="row-title">站点编号</div>
            <div class="row-content">{{ propsData.cd }}</div>
          </div>
          <div class="detail-row">
            <div class="row-title">站点地址</div>
            <div class="row-content">{{ detailData.address }}</div>
          </div>
          <div class="detail-row">
            <div class="row-title">服务提供</div>
            <div class="row-content">南宁交投能源发展有限责任公司</div>
          </div>
          <div class="detail-row">
            <div class="row-title">营业时间</div>
            <div class="row-content">{{ detailData.openingHour }}</div>
          </div>
          <div class="detail-row">
            <div class="row-title">服务电话</div>
            <div class="row-content">19195805376</div>
          </div>
          <div class="detail-row">
            <div class="row-title">停车收费</div>
            <div class="row-content">{{ detailData.parkFee }}</div>
          </div>
<!--          <div class="detail-row">
            <div class="row-title">电费</div>
            <div class="row-content">{{ detailData.electricCharge }}元/度</div>
          </div>
          <div class="detail-row">
            <div class="row-title">服务费</div>
            <div class="row-content">{{ detailData.serviceCharge }}元/度</div>
          </div>-->
        </div>
      </div>

      <div class="detail-title">充电枪信息</div>
      <div class="detail-table">
        <div class="table-main">
          <el-table
            :data="dataList.slice((currentPage - 1)*pageSize,currentPage*pageSize)"
            border
            style="width: 100%">
            <el-table-column
              prop="code"
              label="编号"
              sortable
            />

            <el-table-column
              prop="typeName"
              label="类型"
              sortable
            />

            <el-table-column
              prop="orderStatusName"
              label="状态"
              sortable
            >
              <template slot-scope="scope">
                <span :style="{'color': scope.row.itemColor}">{{ scope.row.statusName }}</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="power"
              label="最大功率(kw)"
              sortable
            />

            <el-table-column
              prop="totalElectricityFees"
              label="电压(v)"
              sortable
            >
              <template slot-scope="{row}">
                <span>{{ row.voltageLowerLimits || "/" }} - {{ row.voltageUpperLimits || "/" }}</span>
              </template>
            </el-table-column>

          </el-table>

          <el-pagination
            @current-change="changePage"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="dataList.length">
          </el-pagination>
        </div>
      </div>
    </div>

    <MultipleLiveVideo ref="MultipleLiveVideo"/>
  </el-dialog>
</template>

<script>
import {Loading} from "element-ui";
import MultipleLiveVideo from "@/components/MultipleLiveVideo/MultipleLiveVideo.vue";

export default {
  name: "ModalChargeDetail",
  components: {MultipleLiveVideo},
  data() {
    return {
      showModal: false,
      propsData: {},
      detailData: {},
      cameraDetail:[],
      dataList: [],
      pageSize: 10,
      currentPage: 1
    };
  },
  methods: {
    open(data) {
      this.propsData = data;
      const loading = Loading.service({
        lock: true,
        text: "正在加载电站信息..",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      Promise.allSettled([this.getChargeDetail(), this.getConnectorList(), this.getStationCameraList()]).then(() => {
        loading.close();
        this.showModal = true;
      });
    },
    openVideo(){
      if(!this.cameraDetail){
        this.$message('暂无可看监控，请联系管理员绑定');
        return;
      }
      this.$refs['MultipleLiveVideo'].open({
        url: this.propsData.sxtdz,
        name: this.propsData.mc,
        videoList: this.cameraDetail
      });
    },
    changePage(page) {
      this.currentPage = page;
    },
    getChargeDetail() {
      return new Promise(resolve => {
        this.$api.getChargeDetail({stationCode: this.propsData.cd})
          .then(res => {
            this.detailData = res.data;
            resolve();
          });
      });
    },
    getConnectorList() {
      return new Promise(resolve => {
        this.$api.getConnectorList({stationCode: this.propsData.cd})
          .then(res => {
            res.data.forEach(item => {
              let color = "";
              switch (item.status) {
                case "50":
                  color = "#289DE6";
                  break;
                case "5":
                  color = "#E88687";
                  break;
                case "6":
                  color = "#e86060";
                  break;
                default:
                  color = "#0CC874";
                  break;
              }

              item.itemColor = color;
            });

            this.dataList = res.data;
            resolve();
          });
      });
    },
    //获取充电站监控列表
    getStationCameraList(){
      return new Promise(resolve => {
          this.$api.getStationCameraList({stationCode: this.propsData.mc}).then(res => {
                if(res.succeed){
                  this.cameraDetail = res.data;
                }
               resolve();
          }).catch(e=>{
              console.log(e);
              resolve();
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../style/_parameter.scss";

::v-deep.el-table .el-table__header-wrapper tr th {
  background-color: #0CC874;
}

::v-deep.el-table td, ::v-deep.el-table th {
  height: 90px;
  color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
}

::v-deep .el-table__body{
  pointer-events: none !important;
}
::v-deep.el-table .cell {
  line-height: 40px;
}

::v-deep.el-table .caret-wrapper{
  transform: scale(2);
  margin-left: 10px;
}
.header {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -30px;
  box-sizing: border-box;
  padding: 0 30px;

  .header-title {
    font-size: 34px;
    color: rgb(181, 228, 255);
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .header-video-btn{
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    margin-left: 60px;
    width: 220px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border:  solid 2px #fff;
    border-radius: 60px;
    cursor: pointer;
    i{
      font-size: 40px;
      margin-right: 10px;
    }
    &:hover{
      opacity: .8;
    }
  }


  .header-close{
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: $red;
    border-radius: 100%;
    i{
      font-size: 40px;
    }
    cursor: pointer;
    &:hover{
      opacity: .8;
    }
  }
}

.detail-title{
  font-size: 32px;
  font-weight: 500;
  margin-top: 30px;
  margin-bottom: 15px;
}

.charge-data-list {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 40px;
}

.charge-data-item {
  float: left;
  width: 32%;
  height: 560px;
  margin-right: 2%;
  margin-bottom: 40px;
  box-sizing: border-box;
  padding: 30px;
  border: solid 2px #ccc;
  border-radius: 10px;

  &:nth-of-type(3n) {
    margin-right: 0;
  }

  .item-title {
    font-size: 30px;
    color: #328CE6;
    padding-bottom: 20px;
    line-height: 40px;
  }

  .item-main {
    position: relative;
    height: calc(100% - 60px);
  }

  .item-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 2;
    width: 120px;
    height: 64px;
    line-height: 60px;
    color: #2E78C4;
    text-align: center;
    border: solid 4px #2E78C4;
    font-size: 28px;
    font-weight: 500;
    border-radius: 10px;
    cursor: pointer;
    //background: #fff;
    &:hover {
      opacity: .8;
    }
  }

  .item-icon {
    display: block;
    float: left;
    width: 200px;
    margin-top: 40px;

    img {
      width: 100%;
    }
  }

  .item-content {
    float: right;
    width: calc(100% - 240px);
  }

  .item-row {
    @extend .clearfix;
    padding: 4px 0;

    .row-title {
      float: left;
      width: 260px;
      line-height: 40px;
      font-size: 28px;
      color: #CFCFD1;
      box-sizing: border-box;
      padding-right: 20px;
      text-align: right;
    }

    .row-content {
      float: left;
      width: calc(100% - 260px);
      line-height: 36px;
      font-size: 28px;
      color: #CFCFD1;
    }
  }
}


.charge-data-detail {
  height: 1600px;
  box-sizing: border-box;
  padding: 40px;

  .detail-wrap {
    height: 384px;
    border-top: solid 2px #ccc;
  }

  .detail-left {
    float: left;
    width: 500px;
    height: 100%;
    box-sizing: border-box;
    padding: 30px;
    border-left: solid 2px #ccc;
    border-right: solid 2px #ccc;
    border-bottom: solid 2px #ccc;

    .detail-title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #D1D2D3;
      margin-bottom: 40px;
    }

    .detail-icon {
      margin: 0 auto;
      width: 260px;
      height: 260px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .detail-status {
      font-size: 30px;
      margin-top: 32px;
      text-align: center;

      &.green {
        color: #63CA2D;
      }

      &.red {
        color: #E6474A;
      }

      &.gray {
        color: #8E8E8E;
      }

      &.purple {
        color: #6B51FF;
      }
    }
  }

  .detail-main {
    float: left;
    width: calc(100% - 500px);
    height: 100%;
    box-sizing: border-box;

    .detail-row {
      float: left;
      width: 40%;
      height: 96px;

      &.width100 {
        width: 100%;

        .row-title, .row-content {
          width: 50%;
        }
      }

      &:nth-of-type(2n) {
        width: 60%;
      }

      box-sizing: border-box;

      .row-title {
        float: left;
        width: 360px;
        height: 96px;
        line-height: 96px;
        border-right: solid 2px #ccc;
        border-bottom: solid 2px #ccc;
        box-sizing: border-box;
        background: rgba(255, 255, 255, .1);
        padding: 0 30px;
        color: #CDCECF;
        font-size: 28px;
      }

      .row-content {
        float: left;
        width: calc(100% - 360px);
        height: 96px;
        line-height: 96px;
        padding: 0 30px;
        box-sizing: border-box;
        border-right: solid 2px #ccc;
        border-bottom: solid 2px #ccc;
        color: #BEBEC2;
        font-size: 28px;
        @extend .omit;
      }
    }
  }
}

.detail-table {
  position: relative;
  height: calc(100% - 522px);
  margin-top: 20px;

  .table-filter {
    height: 96px;
    margin-top: 30px;

    .filter-item {
      float: left;
      @extend .clearfix;
      width: 250px;
      transform: scale(2);
      margin-left: 130px;

      .filter-title {
        float: left;
        width: 80px;
        line-height: 38px;
        color: #BEBEC1;
      }

      .filter-content {
        float: left;
        width: calc(100% - 80px);
      }
    }
  }

  .table-main {
    height: calc(100% - 116px);

    * {
      font-size: 28px !important;
    }

    .el-table tbody tr {
      pointer-events: none;
    }

    .el-table thead {
      color: #fff;

      th.el-table__cell {
        background: transparent;
      }
    }

    .el-table .el-table__cell {
      padding: 25px;
    }

    .el-table .caret-wrapper {
      width: 34px;
      height: 54px;
    }

    .el-table .sort-caret {
      border-width: 10px;

      &.ascending {
        top: 0;
      }

      &.descending {
        bottom: 2px;
      }
    }
  }
}

::v-deep.el-pagination {
  margin-top: 50px;
}

::v-deep.el-pagination * {
  font-size: 28px !important;
}
</style>
